import {
  CreditsService,
  GetUserCreditBalanceOutputDto,
  unwrapApiResponse,
} from '@salesport/api';

export async function getCreditBalance(): Promise<GetUserCreditBalanceOutputDto> {
  const response = await CreditsService.creditsControllerGetUserCredits();
  return unwrapApiResponse(response);
}
